/* eslint-disable react/jsx-props-no-spreading */
import { DrivePicker, DrivePickerDocsView } from '@googleworkspace/drive-picker-react';

import { OAuthResponseEvent } from '@googleworkspace/drive-picker-element';
import { useConfigStore } from '@/client/services/state/configStore';
import { useState } from 'react';
import { getFileNameWithExtension } from '@/client/utils/google/createLocationLink';

interface GooglePickerProps {
  onClose: () => void;
  onSelect: (
    selectedFiles: {
      id: string;
      locationLink: string;
      auth: string;
      mimeType: string;
      fileName: string;
      isFolder: boolean;
    }[],
  ) => void;
}

export const allowedGoogleNativeMimeTypes: string[] = [
  'application/vnd.google-apps.document',
  'application/vnd.google-apps.spreadsheet',
  'application/vnd.google-apps.file',
  'application/vnd.google-apps.presentation',
  'application/vnd.google-apps.script',
  'application/vnd.google-apps.folder',
  'application/pdf',
];

export default function GooglePicker({ onClose, onSelect }: GooglePickerProps) {
  const { config } = useConfigStore();
  // TODO: scope may need to be adjusted, this give full access to the drive which we don't need but
  // it's required for folder content selection. Need to investigate further.
  const scopeRequest = 'https://www.googleapis.com/auth/drive';
  const [sessionOAuthToken, setSessionOAuthToken] = useState<string>('');

  const handleAuthResponse = (e: OAuthResponseEvent) => {
    setSessionOAuthToken(e.detail.access_token);
  };

  return (
    <DrivePicker
      client-id={config.google.clientId}
      developer-key={config.google.developerKey}
      app-id={config.google.appId}
      scope={scopeRequest}
      multiselect
      onPicked={(e: CustomEvent) => {
        onSelect(
          e.detail.docs.map((doc: any) => ({
            id: doc.id,
            auth: sessionOAuthToken,
            // For Google native formats, use the exported mimeType; for regular files, keep the original
            mimeType: doc.mimeType,
            fileName: getFileNameWithExtension(doc.name, doc.mimeType, doc.type === 'folder'),
            isFolder: doc.type === 'folder'
          })),
        )
      }
      }
      onCanceled={onClose}
      onOauthResponse={handleAuthResponse}
      {...(sessionOAuthToken.length && { 'oauth-token': sessionOAuthToken })}
    >
      <DrivePickerDocsView view-id="DOCS" owned-by-me="true" include-folders='true' select-folder-enabled='true' mime-types={allowedGoogleNativeMimeTypes.join(',')}/>
    </DrivePicker>
  );
}
